<template>
    <!-- MODAL GENERIC -->
    <b-modal ref="modal-perk" id="modal-perk" size="md" centered :hide-header="screenSize > 575" hide-footer class="modal-box" body-class="p-0" @hide="cleanRoute">

    <b-container fluid>
        <b-row class="mx-5 my-5 text-center">
          <div>
            <p>This is your gift code for {{ title }}:</p>
          </div>
          <div >
            <!-- COUPOM CODE -->
            <p class="mt-3" v-if="coupom != '' "><span class="font-weight-bold">{{ coupom }}</span></p>
          </div>
           <!-- BUTTON -->
          <div class="button-purchase-perk">
              <b-link :href="ontraportUrl" target="_blank">
                <b-button
                  variant="light"
                  >
                  {{ leftButton }}
                  </b-button>
                </b-link>
            </div>
        </b-row>
        
      </b-container>
    
    </b-modal>
</template>

<script>
import ModernCosmetics from "@/assets/images/centre/perks/perks-modal/ModernCosmetics.jpg";

export default {
  name: "ExpoModalComponent",
  components: {
  },
  props: ["id", "customerInfo", "perksCardsData", "customerLastSubscription"],
  mounted() {
    // if (this.$route.query.id) {
    //   this.$refs['modal-perk'].show();
    // }

    if (this.$route.name === 'Expo' && this.$route.query.step) {
      let index = parseInt(this.$route.query.step) - 1;
      if(this.perksCardsData[index].hasModal) {
        this.$refs['modal-perk'].show();
        this.title = this.perksCardsData[index].modalTitle;
        this.subtitle = this.perksCardsData[index].modalSubtitle;
        this.leftButton = this.perksCardsData[index].leftButton;
        this.image = this.perksCardsData[index].modalImage;
        this.videoUrl = this.perksCardsData[index].modalVideo;
        this.ontraportUrl = this.perksCardsData[index].ontraportUrl;
        this.reviews = this.perksCardsData[index].reviews;
        this.coupoms = this.perksCardsData[index].personalCoupom;
        this.perkDescriptionList = this.perksCardsData[index].perkDescription;
        this.cardId = this.perksCardsData[index].id;
      }
    }

    this.$root.$on("id-content", (content) => {
      this.title = content.modalTitle;
      this.subtitle = content.modalSubtitle;
      this.leftButton = content.leftButton;
      this.image = content.modalImage;
      this.videoUrl = content.modalVideo;
      this.ontraportUrl = content.ontraportUrl;
      this.reviews = content.reviews;
      this.coupoms = content.personalCoupom;
      this.perkDescriptionList = content.perkDescription;
      this.cardId = content.id;
    });
    this.screenSize = window.innerWidth;
  },
  data() {
    return {
      modernCosmeticsImg: ModernCosmetics,
      videoUrl: "",
      image: "",
      title: "",
      subtitle: "",
      leftButton: "",
      ontraportUrl: "",
      reviews: [],
      coupoms: [],
      perkDescriptionList: [],
      cardId: 0,
      screenSize: 1024,
    };
  },
  computed: {
    shouldBehaveLikeFree() {
      if(this.customerInfo && this.customerInfo.user && !this.customerInfo.user.paid) {
        if(this.activeOrCancelingSubscription) {
          return false;
        }
        else if(this.customerInfo.user.plan.toUpperCase() === 'FREE') {
            return true;
        } else {
          if(this.customerInfo.user.plan.toUpperCase().startsWith('TRIAL')) {
            //verifying trial ended
            return this.trialEnded; 
          }
        }
        return true;
      } else {
        //paid users
        if (!this.activeOrCancelingSubscription) {
          return true
        }
      }
      return false;
    },
    trialEnded() {
      if(!this.customerInfo.user.trialEnd) {
        return false;
      }
      let now = new Date();
      let endDate = new Date(this.customerInfo.user.trialEnd);
      return now.getTime() - endDate.getTime() > 0;
    },
    activeOrCancelingSubscription() {
      if(this.customerLastSubscription && !this.customerLastSubscription.status) {
        return false;
      } else if (this.customerLastSubscription && this.customerLastSubscription.status === 'ACTIVE') {
        return true;
      } else if (this.customerLastSubscription && this.customerLastSubscription.status === 'CANCELING') {
        return true;
      }
      return false;
    },
    coupom() {
      let userPlain = this.customerInfo.user.plan.toUpperCase();
      if(this.shouldBehaveLikeFree) {
        return this.coupoms.freeCoupom;
      } else {
        if(userPlain === 'YEARLY') {
        return this.coupoms.yearlyCoupom;
      } else {
        return this.coupoms.monthlyCoupom; //for monthly and trial users
      }
      }
    },
    coupomDescription() {
      let userPlain = this.customerInfo.user.plan.toUpperCase();
      if(userPlain === 'FREE') {
        return this.perkDescriptionList.freeCoupom;
      } else if(userPlain === 'YEARLY') {
        return this.perkDescriptionList.yearlyCoupom;
      } else {
        return this.perkDescriptionList.monthlyCoupom; //for monthly and trial users
      }
    },
  },
    methods: {
    cleanRoute() {
      this.$router.push({
        name: "Expo",
        query: { category: this.$route.query.category },
      }).catch(()=>{});
    },
  },
};
</script>

<style scoped lang="scss">

div.row {
    display: flex;
    justify-content: center;
}

span {
  font-size: 1.5rem;
}

ul.perk-description {
  //padding-left: 1rem;
}

.button-purchase-perk {
  display: flex;
  justify-content: center;
  button {
    font-weight: 700;
    background-color: black; 
    color: white;
    border: none;
    border-radius: 0.4rem;
    padding: 0.5rem 4.5rem 0.5rem 4.5rem;
    margin-top: 1rem;
    &:hover {
      background-color: white;
      color: black; 
    }
  }
}
</style>
